// src/login/Login.js
export const setLoginRedirect = ({state}, value ) => {
  state.loginRedirect = value;
}
export const setHomepageRedirect = ({state}, value ) => {
  state.homepageRedirect = value;
}
export const setBlockAccess= ({state}, value ) => {
  state.blockAccess = value;
}

export const setGoogleAccessToken = ({state}, value ) => {
  state.authState = value;
  state.disableNextStepState[0] = false;
}

// src/dashboard/accountSelect/Account.js
export const getAccountList= ({state}, value ) => {
  state.accountList = value;
}

export const setAccountIndex= ({state}, value ) => {
  if(value === 'reset' ){
    state.isAccountSet = false;
    state.accountIndex = null;
  }else{
    for (const [key, listValue] of Object.entries(state.accountList)){
      if(value === listValue.accountId){
        state.accountIndex = key;
        state.isAccountSet = true
        state.disableNextStepState[1] = false;
      }
    }
  }
}

// src/dashboard/accountSelect/Container.js
export const getContainerList= ({state}, value ) => {
  state.containerList = value;
}

export const setContainerIndex= ({state}, value ) => {
  if(value === 'reset' ){
    state.isContainerSet = false;
    state.containerIndex = null;
  }else{
    for (const [key, listValue] of Object.entries(state.containerList)){
      if(value === listValue.containerId){
        state.containerIndex = key;
        state.isContainerSet = true
        state.disableNextStepState[2] = false;
      }
    }
  }
}

// src/dashboard/accountSelection/Stepper.js
// srce/login/Login.js
export const setActiveStep= ({state}, value ) => {
  state.activeStep = value
}

// dashboard/accountSection/Loader.js
export const addFormattedData = ({state}, value ) => {
  state[value.name] = value.payload;
}

export const loadingDataFlag = ({state}, value ) => {
  state.loadingData = value;
}

export const updateFlag = ({state}, value ) => {
  state[value.name] = value.payload;
}
//////////
// Doncumentation Donut Chart Data
/////////
export const addTagDonutChartData = ({state}, value) =>{
  let tagListRaw = {};

  if(typeof state.tagDataTable !== 'undefined'){
    state.tagDataTable.forEach((tag)=>{
      if( typeof tagListRaw[tag[0].type] == 'undefined'){
        tagListRaw[tag[0].type] = 1;
      }else{
        tagListRaw[tag[0].type] += 1;
      }
    })
  }

  let donutTagData = Object.keys(tagListRaw).map(function(key, index) {
    return {"name":state.docDonutChart.tagNames[key], "value":tagListRaw[key]}
 });

  state.docDonutChart.tags = donutTagData
}

export const addTriggerDonutChartData = ({state}, value) =>{
  let ListRaw = {};

  if(typeof state.triggerDataTable !== 'undefined'){
    state.triggerDataTable.forEach((tag)=>{
      if( typeof ListRaw[tag[0].type] == 'undefined'){
        ListRaw[tag[0].type] = 1;
      }else{
        ListRaw[tag[0].type] += 1;
      }
    })
  }


  let donutData = Object.keys(ListRaw).map(function(key, index) {
    return {"name":state.docDonutChart.triggerNames[key], "value":ListRaw[key]}
 });

  state.docDonutChart.triggers = donutData
}

export const addVariableDonutChartData = ({state}, value) =>{
  let ListRaw = {};

  if(typeof state.variableDataTable !== 'undefined'){
    state.variableDataTable.forEach((tag)=>{
      if( typeof ListRaw[tag[0].type] == 'undefined'){
        ListRaw[tag[0].type] = 1;
      }else{
        ListRaw[tag[0].type] += 1;
      }
    })
  }


  let donutData = Object.keys(ListRaw).map(function(key, index) {
    return {"name":state.docDonutChart.variableNames[key], "value":ListRaw[key]}
 });

  state.docDonutChart.variables = donutData
}

/////////
// recommendations
/////////
export const getRecommendations = ({state}, value ) => {
  let tagFolderList = [];
  let tagNoteList = [];
  let tagNoTriggerList = [];
  let tagPausedList = [];

  let variableFolderList = [];
  let variableNoteList = [];
  let variableNoTagNoTriggerList = [];

  let triggerFolderList = [];
  let triggerNoteList = [];
  let triggerNoTagList = [];


  if(typeof state.liveContainerConfig.tag !== 'undefined'){
    state.liveContainerConfig.tag.forEach((tag)=>{
      if(typeof tag.parentFolderId ==='undefined'){
        tagFolderList.push(tag);
      }
      if(typeof tag.notes ==='undefined'){
        tagNoteList.push(tag);
      }
      if(typeof tag.paused !== 'undefined'){
        tagPausedList.push(tag);
      }
      if(typeof tag.firingTriggerId ==='undefined'){
        tagNoTriggerList.push(tag);
      }
    })
  }

  if(typeof state.liveContainerConfig.trigger !== 'undefined'){
    state.liveContainerConfig.trigger.forEach((tag)=>{
      if(typeof tag.parentFolderId ==='undefined'){
        triggerFolderList.push(tag);
      }
      if(typeof tag.notes ==='undefined'){
        triggerNoteList.push(tag);
      }
    })
  }

  if(typeof state.liveContainerConfig.variable !== 'undefined'){
    state.liveContainerConfig.variable.forEach((tag)=>{
      if(typeof tag.parentFolderId ==='undefined'){
        variableFolderList.push(tag);
      }
      if(typeof tag.notes ==='undefined'){
        variableNoteList.push(tag);
      }
    })
  }

  if(typeof state.triggerDataTable !== 'undefined'){
    state.triggerDataTable.forEach((trigger)=>{
      if(trigger[1].length === 0){
        triggerNoTagList.push(trigger[0]);
      }
    })
  }

  if(typeof state.variableDataTable !== 'undefined'){
    state.variableDataTable.forEach((variable)=>{
      if(variable[1].length === 0 && variable[2].length === 0 && variable[3].length === 0 ){
        if(variable[4]!= null && variable[4].length === 0){
          variableNoTagNoTriggerList.push(variable[0]);
        }
      }
    })
  }


  state.recommendation.reco = [
   {
    "id":"orphanTags",
    "category":"Orphan Tags",
    "title":tagNoTriggerList.length+" Tags have no Trigger",
    "description":"These Tags don't have any triggers assigned to them.  That means they never load.  Our recommendation is to delete them if there is no purpose to keeping them around.",
    "list":tagNoTriggerList,
    "count":tagNoTriggerList.length,
    "tagType":"tag",
    "listType":"container"
    },
    {
     "id":"orphanTriggers",
     "category":"Orphan Triggers",
     "title":triggerNoTagList.length+" Triggers with no Tags",
     "description":"These Triggers aren't assigned to any Tags.  That means they aren't being used.  Our recommendation is to delete them if there is no purpose to keeping them around.",
     "list":triggerNoTagList,
     "count":triggerNoTagList.length,
     "tagType":"trigger",
     "listType":""
     },
     {
      "id":"orphanVariable",
      "category":"Orphan Variables",
      "title":variableNoTagNoTriggerList.length+" Variables with no Tags",
      "description":"These Variables aren't assigned to any Tags, Triggers, or Variables  This means they aren't being used.  Our recommendation is to delete them if there is no purpose to keeping them around.",
      "list":variableNoTagNoTriggerList,
      "count":variableNoTagNoTriggerList.length,
      "tagType":"variable",
      "listType":""
      },
      {
       "id":"pausedTags",
       "category":"Paused Tags",
       "title":tagPausedList.length+" Tags Paused",
       "description":"These Tags are currently in a Paused state.  That means they never fire.  If this is not intended, then we would recommend deleting them.",
       "list":tagPausedList,
       "count":tagPausedList.length,
       "tagType":"tag",
       "listType":"container"
     },
     {
      "id":"folderTags",
      "category":"Tags Without Folders",
      "title":tagFolderList.length+" Tags have no Folder",
      "description":"These are Tags are not assigned to a Folder.  Folders is a helpful way to organizing your tags, so our recommendation would be to group the Tags, Triggers, and Variables that serve similar purpose under a single folder.",
      "list":tagFolderList,
      "count":tagFolderList.length,
      "tagType":"tag",
      "listType":"container"
    },
    {
     "id":"folderTriggers",
     "category":"Triggers Without Folders",
     "title":triggerFolderList.length+" Triggers with no Folder",
     "description":"These are Triggers are not assigned to a Folder.  Folders is a helpful way to organizing your tags, so our recommendation would be to group the Tags, Triggers, and Variables that serve similar purpose under a single folder.",
     "list":triggerFolderList,
     "count":triggerFolderList.length,
     "tagType":"trigger",
     "listType":"container"
    },
    {
    "id":"folderVariable",
    "category":"Variables Without Folders",
    "title":variableFolderList.length+" Variables with no Folder",
    "description":"These are Variables that are not assigned to a Folder.  Folders is a helpful way to organizing your tags, so our recommendation would be to group the Tags, Triggers, and Variables that serve similar purpose under a single folder.",
    "list":variableFolderList,
    "count":variableFolderList.length,
    "tagType":"variable",
    "listType":"container"
    },
    {
     "id":"noteTags",
     "category":"Tags Without Notes",
     "title":tagNoteList.length+" Tags have no Folder",
     "description":"These Tags don't have any notes assigned to them.  Adding Notes is a good way to provide context around why a Tag was setup in a certain way.  Where possible it is our recommendation to add notes to all Tags.",
     "list":tagNoteList,
     "count":tagNoteList.length,
     "tagType":"tag",
     "listType":"container"
    },
    {
    "id":"noteTriggers",
    "category":"Triggers Without Notes",
    "title":triggerNoteList.length+" Triggers with no Folder",
    "description":"These Triggers don't have any notes assigned to them.  Adding Notes is a good way to provide context around why a Triggers was setup in a certain way.  Where possible it is our recommendation to add notes to all Triggers.",
    "list":triggerNoteList,
    "count":triggerNoteList.length,
    "tagType":"trigger",
    "listType":"container"
    },
    {
    "id":"noteVariable",
    "category":"Variables Without Notes",
    "title":variableNoteList.length+" Variables with no Folder",
    "description":"These Variables don't have any notes assigned to them.  Adding Notes is a good way to provide context around why a Tag was setup in a certain way.  Where possible it is our recommendation to add notes to all Variables.",
    "list":variableNoteList,
    "count":variableNoteList.length,
    "tagType":"variable",
    "listType":"container"
    }
  ]

  state.recommendation.totalTagCount = !state.liveContainerConfig.tag ? 0 :state.liveContainerConfig.tag.length;
  state.recommendation.totalTriggerCount = !state.liveContainerConfig.trigger ? 0 : state.liveContainerConfig.trigger.length;
  state.recommendation.totalVariableCount = !state.liveContainerConfig.variable ? 0 : state.liveContainerConfig.variable.length;


}

///////////
// Get Modal Details for Recommendations
////////////
export const setModalData = ({state}, value ) =>{
  state.recommendation.modal= {
    "display":value.display,
    "type":value.type,
    "data":value.data
  }
}

export const closeModal  = ({state}, value ) =>{
  state.recommendation.modal= undefined
}
